import { Component } from '@angular/core';

@Component({
  selector: 'ag-shimmer-loader',
  templateUrl: './shimmer-loader.component.html',
  styleUrls: ['./shimmer-loader.component.scss']
})
export class ShimmerLoaderComponent { }
